import { BaseService } from "../BaseService";
import { AuthService } from "../auth/auth.service";
import { environment } from '../../../../src/environments/environment';
import { HttpClient } from "@angular/common/http";
import { Router } from '@angular/router';
import { Observable, of, throwError } from "rxjs";
import { catchError, concatMap, delay, map, retryWhen, take } from 'rxjs/operators';
import { ApiResult } from "../../models/ApiResult";
import { TherapistModel } from "../../models/api/TherapistModel";
import { TherapistFindResultModel } from "../../models/api/TherapistFindResultModel";
import { Grid_TherapistModel } from "../../models/api/Grid_TherapistModel";
import { Grid_TherapistFindResultModel } from "../../models/api/Grid_TherapistFindResultModel";

export abstract class TherapistBaseService extends BaseService {

    private urlPart: string = 'Therapist';

    constructor(private http: HttpClient, private router: Router, private auth: AuthService) {
        super(http, router, auth);
        this.apiSegmentUrl = this.urlPart;
    };

    /// <summary>
    /// FIND: Retrieves a list of Therapist records from the database
    /// /Therapist
    /// </summary>
    public findTherapist(page: number = 0, size: number = 0, orderBy: string = "", orderDirection: string = "ASC", filter: string = "", systemuserid: number = 0, therapiststatusid: number = 0): Observable<TherapistFindResultModel> {
        // Find Therapist Records

        const url = `${super.getBaseUrl()}?page=${page}&size=${size}&orderBy=${orderBy}&orderDirection=${orderDirection}&filter=${filter}&systemuserid=${systemuserid}&therapiststatusid=${therapiststatusid}`;

        if (!environment.production)
            console.log("Find Therapist: Calling " + url);

        return this.http.get<TherapistFindResultModel>(url)
            .pipe(
                map(next => {
                    let o: TherapistFindResultModel = Object.assign(new TherapistFindResultModel(), next);
                    return o;
                }),
                retryWhen(errors =>
                    errors.pipe(
                        concatMap((error, count) => {
                            if (count > this.RETRY_CEILING) return throwError(error);
                            return this.tokenCheckAndRefresh(error);
                        }),
                        delay(1000),
                    ),
                ),
                catchError(this.errorHandler)
            );
  }

  /// <summary>
  /// FIND: Retrieves a list of Therapist records from the database
  /// /Therapist
  /// </summary>
  public findTherapistPublic(page: number = 0, size: number = 0, orderBy: string = "", orderDirection: string = "ASC", filter: string = "", systemuserid: number = 0, therapiststatusid: number = 0): Observable<TherapistFindResultModel> {
    // Find Therapist Records

    const url = `${super.getBaseUrl()}/publicfind?page=${page}&size=${size}&orderBy=${orderBy}&orderDirection=${orderDirection}&filter=${filter}&systemuserid=${systemuserid}&therapiststatusid=${therapiststatusid}`;

    if (!environment.production)
      console.log("Find Therapist: Calling " + url);

    return this.http.get<TherapistFindResultModel>(url)
      .pipe(
        map(next => {
          let o: TherapistFindResultModel = Object.assign(new TherapistFindResultModel(), next);
          return o;
        }),
        retryWhen(errors =>
          errors.pipe(
            concatMap((error, count) => {
              if (count > this.RETRY_CEILING) return throwError(error);
              return this.tokenCheckAndRefresh(error);
            }),
            delay(1000),
          ),
        ),
        catchError(this.errorHandler)
      );
  }

    /// <summary>
    /// GET: Retrieves a single Therapist record from the database
    /// /Therapist/{therapistid}
    /// </summary>
    /// <param name="therapistid"></param>
    /// <returns></returns>

    public getTherapist(therapistid: number): Observable<TherapistModel> {

        // Get Single Therapist Record

        // TODO: Get Single Therapist Record

        const url = `${super.getBaseUrl()}/${therapistid}`;

        if (!environment.production)
            console.log("Get Therapist: Calling " + url);

        return this.http.get<TherapistModel>(url)
            .pipe(
                map(next => {
                    let o: TherapistModel = Object.assign(new TherapistModel(), next);
                    return o;
                }),
                retryWhen(errors =>
                    errors.pipe(
                        concatMap((error, count) => {
                            if (count > this.RETRY_CEILING) return throwError(error);
                            return this.tokenCheckAndRefresh(error);
                        }),
                        delay(1000),
                    ),
                ),
                catchError(this.errorHandler)
            );
    }

    public findTherapistGrid(page: number = 0, size: number = 0, orderBy: string = "", orderDirection: string = "ASC", filter: string = "", therapistid: number = 0, systemuserid: number = 0, therapiststatusid: number = 0): Observable<Grid_TherapistFindResultModel>
    {
        // Find Grid_Therapist Records

        const url = `${super.getBaseUrl()}/grid?page=${page}&size=${size}&orderBy=${orderBy}&orderDirection=${orderDirection}&filter=${filter}&therapistid=${therapistid}&systemuserid=${systemuserid}&therapiststatusid=${therapiststatusid}`;

        if (!environment.production)
            console.log("Find Grid_Therapist: Calling " + url);

        return this.http.get<Grid_TherapistFindResultModel>(url)
            .pipe(
                map(next => {
                    let o: Grid_TherapistFindResultModel = Object.assign(new Grid_TherapistFindResultModel(), next);
                    return o;
                }),
                retryWhen(errors =>
                    errors.pipe(
                        concatMap((error, count) => {
                            if (count > this.RETRY_CEILING) return throwError(error);
                            return this.tokenCheckAndRefresh(error);
                        }),
                        delay(1000),
                    ),
                ),
                catchError(this.errorHandler)
            );
  }



    /// <summary>
    /// GET: Retrieves a single Grid_Therapist record from the database
    /// /Grid_Therapist/{therapistid}
    /// </summary>
    /// <param name="therapistid"></param>
    /// <returns></returns>
    public getTherapistGridRecord(therapistid: number): Observable<Grid_TherapistModel>
    {

        // Get Single Grid_Therapist Record

        const url = `${super.getBaseUrl()}/grid/${therapistid}`;

        if (!environment.production)
            console.log("Get Therapist: Calling " + url);

        return this.http.get<Grid_TherapistModel>(url)
            .pipe(
                map(next => {
                    let o: Grid_TherapistModel = Object.assign(new Grid_TherapistModel(), next);
                    return o;
                }),
                retryWhen(errors =>
                    errors.pipe(
                        concatMap((error, count) => {
                            if (count > this.RETRY_CEILING) return throwError(error);
                            return this.tokenCheckAndRefresh(error);
                        }),
                        delay(1000),
                    ),
                ),
                catchError(this.errorHandler)
            );
    }
  /// <summary>
  /// GET: Retrieves all Therapist records from the database
  /// /Therapist/
  /// </summary>
  /// <returns></returns>
  public getAllTherapists(): Observable<TherapistModel[]> {
    const url = `${super.getBaseUrl()}`;

    if (!environment.production)
      console.log("Get All Therapists: Calling " + url);

    return this.http.get<any>(url).pipe(
      map(response => {
        const data = Array.isArray(response.data)
          ? response.data
          : Array.from(response.data as any);

        return data.map((item: any) => Object.assign(new TherapistModel(), item));
      }),
      retryWhen(errors =>
        errors.pipe(
          concatMap((error, count) => {
            if (count > this.RETRY_CEILING) return throwError(error);
            return this.tokenCheckAndRefresh(error);
          }),
          delay(1000),
        )
      ),
      catchError(this.errorHandler)
    );
  }


    /// <summary>
    /// POST: Adds a new Therapist record to the database
    /// /Therapist/{therapistid}
    /// </summary>
    /// <param name="therapistid"></param>
    /// <returns></returns>
    public createTherapist(newRecord: TherapistModel): Observable<TherapistModel> {
        // Add Single Therapist Record

        const url = `${super.getBaseUrl()}`;

        if (!environment.production)
            console.log("Create Therapist:Calling " + url);

        return this.http.post<TherapistModel>(url, newRecord)
            .pipe(
                map(next => {
                    let o: TherapistModel = Object.assign(new TherapistModel(), next);
                    return o;
                }),
                retryWhen(errors =>
                    errors.pipe(
                        concatMap((error, count) => {
                            if (count > this.RETRY_CEILING) return throwError(error);
                            return this.tokenCheckAndRefresh(error);
                        }),
                        delay(1000),
                    ),
                ),
                catchError(this.errorHandler)
            );
    }

    /// <summary>
    /// PUT: Updates an existing Therapist record in the database
    /// /Therapist/{therapistid}
    /// </summary>
    /// <param name="therapistid"></param>
    /// <returns></returns>
    public updateTherapist(therapistid: number, updatedRecord: TherapistModel): Observable<TherapistModel>
    {
        // Update Single Therapist Record

        const url = `${super.getBaseUrl()}/${therapistid}`;

        if (!environment.production)
            console.log("Update Therapist: Calling " + url);

        return this.http.put<TherapistModel>(url, updatedRecord)
            .pipe(
                map(next => {
                    let o: TherapistModel = Object.assign(new TherapistModel(), next);
                    return o;
                }),
                retryWhen(errors =>
                    errors.pipe(
                        concatMap((error, count) => {
                            if (count > this.RETRY_CEILING) return throwError(error);
                            return this.tokenCheckAndRefresh(error);
                        }),
                        delay(1000),
                    ),
                ),
                catchError(this.errorHandler)
            );
    }

    public updateTherapistRecord(updatedRecord: TherapistModel): Observable<TherapistModel>
    {
        return this.updateTherapist(updatedRecord.therapistID, updatedRecord);
    }

    /// <summary>
    /// DELETE: Deletes an existing Therapist record from the database
    /// /Therapist/{therapistid}
    /// </summary>
    /// <param name="therapistid"></param>
    /// <returns></returns>
    public deleteTherapist(therapistid: number): Observable<ApiResult>
    {
        // Delete Single Therapist Record

        const url = `${super.getBaseUrl()}/${therapistid}`;

        if (!environment.production)
            console.log("Delete Therapist: Calling " + url);

        return this.http.delete<ApiResult>(url)
            .pipe(
                map(next => {
                    let o: ApiResult = new ApiResult();
                    o.success = true;
                    return o;
                }),
                retryWhen(errors =>
                    errors.pipe(
                        concatMap((error, count) => {
                            if (count > this.RETRY_CEILING) return throwError(error);
                            return this.tokenCheckAndRefresh(error);
                        }),
                        delay(1000),
                    ),
                ),
                catchError(this.errorHandler)
            );
    }

    public deleteTherapistRecord(deleteRecord: TherapistModel): Observable<ApiResult>
    {
        // Delete Single Therapist Record
        return this.deleteTherapist(deleteRecord.therapistID);
    }

}
